import { ready } from '@titanio/utils'
import app from '@config/app'
import tracking from '@modules/tracking'
import ThirdParty from '@titanio/thirdparty'

ready(() => {
  setTimeout(app.loader(), 0)
  setTimeout(tracking.loader(), 0)

  new ThirdParty('[data-loader="carousel"]', () => {
    import(
      /* webpackChunkName: "carousel" */
      '@magnetita/glider/carousel'
    ).then(({ default: Carousel }) => {
      new Carousel({ target: 'contents' }).mount()
    })
  })
})
